<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  title: String,
  options: Array,
  placeholder: String,
  modelValue: [String, Number, Boolean], // Added for v-model support
});

defineEmits(["update:modelValue"]);

const hasOptgroup = computed(() =>
  props.options?.some((option) => option.options)
);
</script>

<template>
  <div class="col-sm-4 mb-2">
    <span class="text-sm">
      <b>{{ props.title }}</b>
    </span>
    <select
      class="form-control"
      style="width: 100%"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option v-if="hasOptgroup" value="">{{ props.placeholder }}</option>

      <template v-if="!hasOptgroup">
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </template>

      <template v-else v-for="group in options" :key="group.label">
        <optgroup :label="group.label">
          <option
            v-for="option in group.options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </optgroup>
      </template>
    </select>
  </div>
</template>
